import { EntityTypes } from "../../EntityTypes";
import { ILanguageResource } from "../../languages";
import { IMediaResource } from "../../media";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { RelationalValue } from "../../utils/filters";
import { buildResourceIRI, getResourceUuid } from "../../utils/getResourceUuid";
import { IUser, IUserEditProfileNotificationSettings, IUserResource, UserStatus } from "../types";

export type IUserUpdateParameters = {
    email: string;
    name?: string | null;
    surname?: string | null;

    password?: string | null;
    checkedPassword?: string | null;
    status?: UserStatus;

    language?: RelationalValue<ILanguageResource>; // IRI Reference
    notificationSettings?: IUserEditProfileNotificationSettings;
    discordUsername?: string | null;
    bio?: string | null;
    city?: string;
    avatar?: RelationalValue<IMediaResource> | null;

    learnersAsTutor?: Array<RelationalValue<IUserResource>>;
    tutorsAsLearner?: Array<RelationalValue<IUserResource>>;

    user: RelationalValue<IUserResource>;
};

export type IUserUpdateMutationResult = IUser;

export const userUpdateMutation: IApiMutationFunction<IUserUpdateParameters> = ({
    user,
    avatar,
    language,
    learnersAsTutor,
    tutorsAsLearner,
    ...data
}) => {
    return {
        method: "PUT",
        url: `users/${getResourceUuid(user)}`,
        data: {
            avatar: avatar ? buildResourceIRI(EntityTypes.MEDIA, avatar) : undefined,
            language: buildResourceIRI(EntityTypes.LANGUAGE, language),
            tutorsAsLearner: tutorsAsLearner?.map(tutor => buildResourceIRI(EntityTypes.USER, tutor)),
            learnersAsTutor: learnersAsTutor?.map(learner => buildResourceIRI(EntityTypes.USER, learner)),
            ...data,
        },
    };
};

export const useUserUpdateMutation = createApiMutationHook<IUserUpdateParameters, IUserUpdateMutationResult>(
    userUpdateMutation,
);
